import { API } from './api';

export const GetPayments = (params: any) =>
  API.get('/cabinet/payments/', params);

export const DownloadReceipt = (docId: string) =>
  API.get(`/cash/online/receipt/${docId}/`);